import script from "./goRinSyo0076.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0076.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0076.vue?vue&type=style&index=0&id=0d545986&lang=scss"

const __exports__ = script;

export default __exports__